(function () {
  function loadBrands(d) {
    var wrap = d.querySelector('[data-amzh-brands]');
    if (!wrap || wrap.__loaded) return; wrap.__loaded = true;
    fetch('/?section_id=amz-brand-list').then(function (r) { return r.text(); }).then(function (html) {
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var list = tmp.querySelector('[data-amzh-brand-list]');
      if (!list) { wrap.innerHTML = ''; return; }
      wrap.innerHTML = '';
      wrap.appendChild(list);
      var count = list.children.length;
      if (count > 9) {
        wrap.classList.add('is-collapsed');
        var btn = document.createElement('button');
        btn.type = 'button'; btn.className = 'amzh__brands-toggle';
        btn.textContent = 'Show all ' + count + ' brands';
        btn.addEventListener('click', function () {
          var collapsed = wrap.classList.toggle('is-collapsed');
          btn.textContent = collapsed ? 'Show all ' + count + ' brands' : 'Show fewer brands';
        });
        wrap.appendChild(btn);
      }
    }).catch(function () { wrap.__loaded = false; });
  }
  function init(root) {
    if (!root || root.__amzh) return; root.__amzh = true;
    var d = root.querySelector('[data-amzh-drawer]');
    if (!d) return;
    d.classList.add('amzh');
    document.body.appendChild(d);
    function open() { d.hidden = false; document.body.classList.add('amzh-lock'); loadBrands(d); var c = d.querySelector('.amzh__close'); if (c) c.focus(); }
    function close() { d.hidden = true; document.body.classList.remove('amzh-lock'); }
    root.querySelectorAll('[data-amzh-open]').forEach(function (b) { b.addEventListener('click', open); });
    d.querySelectorAll('[data-amzh-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !d.hidden) close(); });
  }
  function setCount(n) {
    document.querySelectorAll('[data-amz-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = Number(n) === 0;
    });
  }
  window.amzUpdateCartCount = setCount;
  function refreshCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (c) { setCount(c.item_count); }).catch(function () {});
  }
  function all() {
    document.querySelectorAll('[data-amzh]').forEach(init);
    document.querySelectorAll('[data-amz-cart-count]').forEach(function (el) { el.hidden = el.textContent.trim() === '0'; });
  }
  document.addEventListener('cart:update', refreshCount);
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCount(); });
  if (document.readyState !== 'loading') all(); else document.addEventListener('DOMContentLoaded', all);
  document.addEventListener('shopify:section:load', all);
})();